import common from './common.js';
import auth from './auth.js';
import pagination from './pagination.js';
import validation from './validation.js';
import message from './message.js';
import pages from './pages.js';
import components from './components.js';

export default {
  common,
  auth,
  pagination,
  validation,
  message,
  pages,
  components,
};
